export default __webpack_public_path__ + "static/media/references_l.2c4c1e46.jpg";